export const MARKETING_PAYMENT_RECEIVE = {
  PRIMARY_KEY: "user_id",
  BASE_PATH: "marketing-promotion/payment-receives",
  GET_ALL: "marketing-promotion-plan/payment-receives",
  CREATE: "marketing-promotion-plan/payment-receive",
  DELETE: "/marketing-promotion-plan/payment-receives/delete",
};
